import { useRolesQuery } from '@/features/roles/hooks/use-roles';

// PRD 15 §2.2: when the active role catalog is unavailable, fall back silently
// to the seed three so filters/checkboxes never present an empty list.
const SEED_ROLE_FALLBACK = ['OPERATION', 'CONTENT', 'SYSTEM'] as const;

// Non-reserved (i.e. non-Root) role names that can be assigned to or filtered on.
// Reserved roles are surfaced separately via the `__ROOT__` filter sentinel.
export function useAssignableRoles(): readonly string[] {
  const rolesQuery = useRolesQuery();
  if (rolesQuery.data && rolesQuery.data.length > 0) {
    return rolesQuery.data.filter((r) => !r.isReserved).map((r) => r.name);
  }
  return SEED_ROLE_FALLBACK;
}
